import axios from "@/api/axios";

async function sendGetStageLinksRequest(isIntraoral) {
  try {
    console.log("sendGetStageLinksRequest");
    let url = `/api/ortho/getStageLinks`;
    // ?patientId=${vueApp.patientId}&s3Path=${vueApp.stlBaseUrl}`;
    let requestData = {
      patientId: vueApp.patientId,
      s3Path: vueApp.stlBaseUrl,
      isIntraoral: isIntraoral,
    };
    const response = await axios.get(url, { params: requestData });
    const responseData = response.data;
    return responseData.value;
  } catch (e) {
    // console.log("checkPatientIsRestitching error", e);
    return false;
  }
}

async function sendOrthoSaveStageRequest(stage, blob) {
  console.log("sendOrthoAddStageRequest");
  let url = "/api/ortho/saveStage";
  let formData = new FormData();
  formData.append("file", blob, stage.zipName);
  formData.append("patientId", vueApp.patientId);
  formData.append("s3Path", vueApp.stlBaseUrl);
  var config = {};
  config.headers = {
    "content-type": "multipart/form-data",
  };

  const response = await axios.post(url, formData, config);
  return response;
}

async function sendOrthoRemoveStageRequest(stage) {
  console.log("sendOrthoRemoveStageRequest", stage);
  let url = "/api/ortho/removeStage";
  let formData = new FormData();
  formData.append("patientId", vueApp.patientId);
  formData.append("s3Path", vueApp.stlBaseUrl);
  formData.append("stageId", stage.id);
  if (stage.zipName) formData.append("stageZipName", stage.zipName);

  var config = {};
  config.headers = {
    "content-type": "multipart/form-data",
  };

  const response = await axios.post(url, formData, config);
  return response;
}

export {
  sendOrthoSaveStageRequest,
  sendGetStageLinksRequest,
  sendOrthoRemoveStageRequest,
};
